/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/32/close-lightblue': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M9.3 22.7c.2.2.4.3.7.3s.5-.1.7-.3l5.3-5.3 5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L17.4 16l5.3-5.3c.4-.4.4-1 0-1.4s-1-.4-1.4 0L16 14.6l-5.3-5.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l5.3 5.3-5.3 5.3c-.4.4-.4 1 0 1.4z" _fill="#0073E6"/>'
  }
})
